<section class="bg-beige">
  <div class="be-container be-container--md be-container--py">
    <header>
      <h2 class="be-layout-title mb-5 text-navy-900">Profile</h2>
    </header>
    <p class="profile-text my-4">
      This additional information will help us provide you with the most
      accurate and personalized experience.
    </p>
    <nav class="profile-nav">
      @for (item of profileNav; track item) {
        <span class="nav-span">
          <a
            class="profile-nav__link be-text-sm"
            routerLinkActive="profile-nav__link--active"
            [routerLink]="item.link"
            >{{ item.label }}</a
            >
            @if (item.refreshRequired) {
              <app-icon-info
                class="info-icon"
                width="16"
                height="16"
                #tooltip="matTooltip"
                matTooltip="Please update"
                matTooltipPosition="above"
                matTooltipHideDelay="10"
                matToolTipClass="tooltip"
                aria-label="Button that displays a tooltip that hides when scrolled out of the container"
              ></app-icon-info>
            }
          </span>
        }
      </nav>
      <router-outlet></router-outlet>
    </div>
  </section>
